import { redirect } from 'react-router-dom'

import { FlowType } from '@cash-web/protos/squareup/cash/plasma/flows/FlowProto.pb'
import { JourneyRoute } from '@cash-web/shared-journey-util-main'

import { getFlowInitiationDataLoader, getFlowTypeLoader } from './getFlowLoader'
import { unsupportedFlowRoutes } from './unsupportedFlowRoutes'

export const flowClientRoutes = [
  ...unsupportedFlowRoutes,
  {
    id: 'flow-type-view-money-pool',
    trackingName: 'Flow Type View Money Pool',
    path: `dl/flow/type/${FlowType.VIEW_MONEY_POOL}`,
    loader: async () => {
      throw redirect('/web/view/activity/not-supported')
    },
  },
  {
    id: 'flow-view-money-pool',
    trackingName: 'Flow View Money Pool',
    path: `dl/flow/${FlowType.VIEW_MONEY_POOL}`,
    loader: async () => {
      throw redirect('/web/view/activity/not-supported')
    },
  },
  {
    id: 'journey-get-flow-initiation-data',
    trackingName: 'Journey Get Flow Initiation Data',
    path: 'dl/flow/:initiationData',
    lazy: async () => ({
      Component: (await import('../components/JourneyGetFlow')).JourneyGetFlow,
    }),
  },
  {
    id: 'journey-get-flow-initiation-data/loader',
    trackingName: 'Journey Set Flow',
    path: 'web/flow/loader/:initiationData',
    lazy: async () => ({
      Component: (await import('../components/JourneySetFlow')).JourneySetFlow,
    }),
    loader: getFlowInitiationDataLoader,
  },
  {
    id: 'journey-get-flow-type',
    trackingName: 'Journey Get Flow Type',
    path: 'dl/flow/type/:flowType',
    lazy: async () => ({
      Component: (await import('../components/JourneyGetFlow')).JourneyGetFlow,
    }),
  },
  {
    id: 'journey-get-flow-type/loader',
    trackingName: 'Journey Set Flow Type',
    path: 'web/flow/loader/type/:flowType',
    lazy: async () => ({
      Component: (await import('../components/JourneySetFlow')).JourneySetFlow,
    }),
    loader: getFlowTypeLoader,
  },
  {
    id: 'journey-complete-scenario-with-flow-token',
    trackingName: 'Journey Complete Scenario with Flow Token',
    path: 'dl/scenario/complete/:clientScenario/:flowToken',
    lazy: async () => ({
      Component: (await import('../components/JourneyCompleteScenario')).JourneyCompleteScenario,
    }),
  },
  {
    id: 'journey-preauthed-complete-scenario',
    trackingName: 'Journey Preauthed Complete Scenario',
    path: 'dl/scenario/preauthed-complete/:clientScenario/:flowToken',
    lazy: async () => ({
      Component: (await import('../components/JourneyCompleteScenario')).JourneyCompleteScenario,
    }),
  },
  {
    id: 'journey-complete-scenario',
    trackingName: 'Journey Complete Scenario',
    path: 'dl/scenario/:clientScenario',
    lazy: async () => ({
      Component: (await import('../components/JourneyCompleteScenario')).JourneyCompleteScenario,
    }),
  },
  {
    id: 'journey-blocker-descriptors',
    trackingName: 'Journey Blocker Descriptors',
    path: 'web/flow/blocker-descriptors',
    lazy: async () => ({
      Component: (await import('../components/JourneyBlockerDescriptors')).JourneyBlockerDescriptors,
    }),
  },
] as const satisfies JourneyRoute[]
